import { Injectable, NgZone, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OnExecuteData,
  OnExecuteErrorData,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaLoaderService,
  ReCaptchaV3Service,
} from 'ng-recaptcha';
import { filter, take } from 'rxjs/operators';
import { SiteContextFacade } from '../site-context/facade/site-context.facade';

const BASE_SITE_GENERIC = 'rentalGeneric';

@Injectable()
export class BoelsReCaptchaV3Service {
  private reCaptchaV3Service: ReCaptchaV3Service;
  onExecute: Observable<OnExecuteData>;
  onExecuteError: Observable<OnExecuteErrorData>;

  constructor() {
    const zone = inject(NgZone);
    const siteKey = inject(RECAPTCHA_V3_SITE_KEY);
    const siteContextFacade = inject(SiteContextFacade);
    const recaptchaLoader = inject(RecaptchaLoaderService);

    siteContextFacade
      .getActiveBaseSiteEntity()
      .pipe(
        filter((value) => value?.uid !== BASE_SITE_GENERIC),
        take(1),
      )
      .subscribe(() => {
        this.reCaptchaV3Service = new ReCaptchaV3Service(
          zone,
          recaptchaLoader,
          siteKey,
        );
        this.onExecute = this.reCaptchaV3Service.onExecute;
        this.onExecuteError = this.reCaptchaV3Service.onExecuteError;
      });
  }

  execute(action: string): Observable<string> {
    return this.reCaptchaV3Service.execute(action);
  }
}
